import { useSelector } from 'react-redux';
import { fetchOrganizationBetaFeatureStatus } from 'resources/Organization/BetaFeatures/Data';
import { canUseInvoicesLite } from 'resources/Organization/Features/FeaturesData';

import { useDataFetcherV2 } from 'components/Common/Data/useDataFetcher';
import { useHomepageOptin } from 'components/DashboardV2/common/hooks/useHomepageOptin';

export const NEW_HOMEPAGE = 'new_homepage';

export const useHomepageMVP = (): { shouldShowHomepageMvp: boolean; homepageBetaFeatureActive: boolean } => {
  const [, homepageBetaFeatureActive] = useDataFetcherV2(fetchOrganizationBetaFeatureStatus(NEW_HOMEPAGE));
  const isInvoicesLite = useSelector(canUseInvoicesLite);
  const { isHomepageOptedin } = useHomepageOptin();
  const shouldShowHomepageMvp = [homepageBetaFeatureActive, isInvoicesLite, isHomepageOptedin].some(Boolean);
  return { shouldShowHomepageMvp, homepageBetaFeatureActive };
};
